/**
 * HMAC-SHA256 for relay WebSocket authentication.
 */

export function hexToBytes(hex: string): Uint8Array {
  const bytes = new Uint8Array(hex.length / 2)
  for (let i = 0; i < hex.length; i += 2) {
    bytes[i / 2] = parseInt(hex.substring(i, i + 2), 16)
  }
  return bytes
}

export function bytesToHex(bytes: Uint8Array): string {
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
}

async function importHmacKey(keyBytes: Uint8Array): Promise<CryptoKey> {
  return crypto.subtle.importKey(
    'raw',
    keyBytes.buffer as ArrayBuffer,
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  )
}

export async function hashKey(keyHex: string): Promise<string> {
  const bytes = new TextEncoder().encode(keyHex)
  const hash = await crypto.subtle.digest('SHA-256', bytes.buffer as ArrayBuffer)
  return bytesToHex(new Uint8Array(hash))
}

export async function computeHMAC(message: string, keyHex: string): Promise<string> {
  const keyBytes = hexToBytes(keyHex)
  const key = await importHmacKey(keyBytes)
  const encoded = new TextEncoder().encode(message)
  const signature = await crypto.subtle.sign('HMAC', key, encoded.buffer as ArrayBuffer)
  return bytesToHex(new Uint8Array(signature))
}
